// extracted by mini-css-extract-plugin
export default {"summary-modal-content":"client-components-common-workOrderDetail-workOrderSummary-___workOrderSummary__summary-modal-content___22aFE"};